<template>
	<div class="headerTop">
		<header class="head">
			<!-- 头部提示栏  -->
			<div class="head_top">
				<div class="head_top_div flex_between word">
					<span class="head_top_l">{{$t('headerTop.wel')}}</span>
					<span class="head_top_r flex_end">
						<a href="javaScript:void(0)" @click="login" v-if="!islogin">{{$t('headerTop.login')}}</a>
						<a href="javaScript:void(0)" @click="outLogin" v-else>{{$t('vip.out')}}</a>
						<a href="javaScript:void(0);" @click="tomessage">
							{{$t('headerTop.msg')}}(
							<span class="head_news">{{nums ? nums : 0}}</span>）
						</a>
						<!-- <a class="head_language flex_center" href="javaScript:void(0)" @click="changeLanguage">
							<img class="head_cn" src="@/assets/images/china.png" alt v-if="thisLang == '中文'" />
							<img class="head_cn" src="@/assets/images/en.png" alt v-else />
							<span>{{thisLang}}</span>
							<img class="head_down" src="@/assets/images/down.png" alt @click="chose" />
							<div class="language-box" :class="{'show' : showLan}">
								<div class="lan-box-item" @click.stop="changeFn('cn')">
									<img class="head_cn" src="@/assets/images/china.png" alt />
									<span>中文</span>
								</div>
								<div class="lan-box-item" @click.stop="changeFn('en')">
									<img class="head_cn" src="@/assets/images/en.png" alt />
									<span>English</span>
								</div>
							</div>
						</a> -->
					</span>
				</div>
			</div>
		</header>
	</div>
</template>

<script>
	import "@/assets/css/header.css";
	import {
		NaviLanguage
	} from "../../assets/js/global"
	export default {
		name: "headerTop",
		data() {
			return {
				message: "登录",
				showLan: false,
				thisLang: '中文',
				islogin: false, //是否登录
				token: '',
				nums: ""
			};
		},
		props: {
			num: {
				type: String
			}
		},
		methods: {
			getNew() {
				this.$get("/api/message/unread/count", {
					token: sessionStorage.getItem('token')
				}).then(res => {
					this.nums = res.data;
				});
			},
			tomessage() {
				this.$router.push('/mine/message');
			},
			login() {
				this.$router.push("/login");
			},
			chose() {

			},
			//修改语言
			changeFn(i) {
				this.$i18n.locale = i;
				this.showLan = false;
				if (i === "cn") {
					i = 'zh_CN';
					this.thisLang = '中文'
				} else {
					i = 'en_US';
					this.thisLang = 'English'
				}
				localStorage.setItem('lang', i)
				this.$router.go(0);
			},
			changeLanguage() {
				this.showLan = !this.showLan
			},
			//退出登录
			outLogin() {
				this.$confirm(this.$t('Signin.tipsOut'), this.$t('Tips.Tips'), {
					confirmButtonText: this.$t('Tips.confirm'),
					cancelButtonText: this.$t('Tips.cancel'),
					type: 'warning'
				}).then(() => {
					let url = '/api/user/loginOut';
					let data = {
						token: this.token
					};
					this.$post(url, data).then(res => {
						sessionStorage.clear();
						location.reload();
						this.$message({
							type: 'success',
							message: this.$t('Signin.outSuc')
						});
					})
				}).catch(() => {});
			}
		},
		mounted() {
			//选择过语言就使用选择的，否则使用浏览器语言
			let i = !!localStorage.getItem('lang') ? localStorage.getItem('lang') : NaviLanguage();
			this.thisLang = i === 'zh_CN' ? '中文' : 'English';
			this.$i18n.locale = i === 'zh_CN' ? 'cn' : 'en';
			this.islogin = !!sessionStorage.getItem('token');
			this.token = sessionStorage.getItem('token');
			if (this.token) {
				this.getNew()
			}

		}
	};
</script>

<style scoped>

</style>
<style>
	.head_language {
		position: relative;
	}

	.language-box {
		height: 0;
		width: 100%;
		position: absolute;
		top: 30px;
		left: 0;
		opacity: 0;
		transition: all 0.3s ease;
		border: 1px solid #E3E3E3;
		background: #fff;
		z-index: 200;
	}

	.language-box.show {
		height: 70px;
		opacity: 1;
	}

	.lan-box-item {
		height: 50%;
		display: block;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-left: 0;
		cursor: pointer;
		box-sizing: border-box;
	}

	.lan-box-item>span {
		width: 45px;
	}

	.lan-box-item:first-child {
		border-bottom: 1px solid #E3E3E3;
	}
</style>



// WEBPACK FOOTER //
// src/components/assembly/HeaderTop.vue